import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faStickyNote,
  faQuestionCircle,
  faArrowRight,
} from "@fortawesome/free-solid-svg-icons";
import "./Services.css";
import AOS from "aos";
import "aos/dist/aos.css";

const Services = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: "ease-in-out",
      once: true,
    });
  }, []);

  return (
    <section className="services-container">
      <h1 className="service-title hero" data-aos="fade-up">
        Our Services
      </h1>
      <div className="service-links" data-aos="fade-up">
        <Link to="/services/notes" className="service-link">
          <div className="service-link-content">
            <FontAwesomeIcon icon={faStickyNote} className="icon" />
            <div className="service-info">
              <span className="service-name">Notes</span>
              <p className="service-description">
                Access comprehensive notes to aid your study and revision.
              </p>
            </div>
            <FontAwesomeIcon icon={faArrowRight} className="arrow-right" />
          </div>
        </Link>
        <Link to="/services/qna" className="service-link">
          <div className="service-link-content">
            <FontAwesomeIcon icon={faQuestionCircle} className="icon" />
            <div className="service-info">
              <span className="service-name">Question & Answer</span>
              <p className="service-description">
                Access a comprehensive collection of Q&A PDFs.
              </p>
            </div>
            <FontAwesomeIcon icon={faArrowRight} className="arrow-right" />
          </div>
        </Link>
        {/* <Link to="/services/online-test" className="service-link">
          <div className="service-link-content">
            <FontAwesomeIcon icon={faQuestionCircle} className="icon" />
            <div className="service-info">
              <span className="service-name">Online Test</span>
              <p className="service-description">Give online test for free.</p>
            </div>
            <FontAwesomeIcon icon={faArrowRight} className="arrow-right" />
          </div>
        </Link> */}
        {/* <Link to="/services/books" className="service-link">
          <div className="service-link-content">
            <FontAwesomeIcon icon={faQuestionCircle} className="icon" />
            <div className="service-info">
              <span className="service-name">Books</span>
              <p className="service-description">
                Get our Class 11 and 12 books, full of questions to boost your
                preparation.
              </p>
            </div>
            <FontAwesomeIcon icon={faArrowRight} className="arrow-right" />
          </div>
        </Link> */}
      </div>
      <div className="service-stats" data-aos="fade-up">
        <div className="stat">
          <h3>0</h3>
          <p>Notes Available</p>
          {/* <p className="stat-description">
            Study notes are on the way. Come back Soon.
          </p> */}
        </div>
        <div className="stat">
          <h3>3</h3>
          <p>Questions Pdfs</p>
          {/* <p className="stat-description">
            Q&A content is coming soon. Stay tuned.
          </p> */}
        </div>
        <div className="stat">
          <h3>Coming Soon</h3>
          <p>Success Rate</p>
          <p className="stat-description">
            We’re dedicated to tracking and improving the effectiveness of our
            resources as we grow.
          </p>
        </div>
      </div>

      <div className="cta" data-aos="fade-up">
        <Link to="/contact" className="cta-button">
          Get in Touch
        </Link>
      </div>
    </section>
  );
};

export default Services;
